<template>
  <b-row class="justify-content-md-center m-0">
    <b-col lg="6">
      <div style="height: 15vh" />
      <b-row class="justify-content-md-center m-0">
        <div
          class="h1 d-flex justify-content-center align-items-center font-weight-bold d-inline-block border-bottom border-warning m-4 p-4"
        >
          <div>Sorry, The page you are trying to access can't be reached.</div>
        </div>
      </b-row>
      <div class="pt-0 mt-0 pl-4 ml-4">
        <div class="h4 font-weight-bold">
          Contact us:
          <a href="mailto: 4life@mail.kmutt.ac.th">4life@mail.kmutt.ac.th</a>
        </div>
        <b-button variant="primary" class="mt-2" href="/"> Explore </b-button>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
